import React from 'react';
import { Form, Select } from 'antd';
import TagSelect from '../common/TagSelect';
const { Option } = Select;

const TagEditor = ({ 
  tags = [],
  isTemplateActive = false
}) => {
  return (
    <>
      <Form.Item
        name="actionType"
        label="标签操作"
        rules={[{ required: true, message: '请选择标签操作' }]}
        style={{ marginBottom: '10px' }}
      >
        <Select 
          placeholder="请选择标签操作" 
          style={{ width: '100%' }}
          disabled={isTemplateActive}
        >
          <Option value="ADD_TAG">添加标签</Option>
          <Option value="REMOVE_TAG">移除标签</Option>
        </Select>
      </Form.Item>

      <Form.Item
        name={['actionParams', 'tagId']}
        label="标签"
        rules={[{ required: true, message: '请选择标签' }]}
        style={{ marginBottom: '10px' }}
      >
        <TagSelect
          mode="single"
          placeholder="请选择标签"
          disabled={isTemplateActive}
          width={'100%'}
        />
      </Form.Item>
    </>
  );
};

export default TagEditor; 